<template>
  <div class="page-content">
    <h1 class="page-title" style="margin-bottom: 20px;">{{ $locale("sideMenu.businessDailyUpdate") }}</h1>
    <!-- Search Area -->
   <el-form label-position="top" :model="formData" :rules="formRules" ref="ruleForm">
    <el-form-item prop="date" :label="$locale('trans.other.date')">
     <CommDatePicker v-model="formData.date" :value.sync="formData.date" :showWeekly="true" />
    </el-form-item>
    <el-row :gutter="30">
      <el-col :span="6">
        <el-form-item prop="cinemaId" :label="$locale('pdfFilmFeeBalance.th.cinema')">
          <el-select v-model="formData.cinemaId">
            <el-option
              v-for="item in cinemaList"
              :key="item.id"
              :value="item.id"
              :label="item.name"
            />
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="30">
      <el-col :span="6">
        <el-form-item prop="platform" :label="$locale('cashierReport.dialog.formField.device')">
          <el-select v-model="formData.platform">
            <el-option label="cms" value="cms"></el-option>
            <el-option label="online" value="pwa"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-button class="egl-btn-yellow confirm" @click="regenClose_fn">{{ $locale("global.confirm2") }}</el-button>
      </el-col>
    </el-row>
   </el-form>
  </div>
</template>
<script>

import CommDatePicker from "@/components/common/CommDatePicker";
import { getCinemaList } from "@/helpers/service/api/common";
import { regenCloseService } from "@/helpers/service/api/dailyBusinessUpdate";
import countDownAlert from "@/utils/countDownAlert";
export default {
  created() {
    getCinemaList().then(res => {
      this.cinemaList = res.data.data;
    });
  },
  data() {
    return {
      formData: {
        date: this.$moment().valueOf(),
        cinemaId: "",
        platform: "",
      },
      formRules: {
        date: [ { required: true, message: this.$locale("form.plsSelectDate"), trigger: "blur" } ],
        cinemaId: [ { required: true, message: this.$locale("form.plsSelectCinema"), trigger: "blur" } ],
        platform: [ { required: true, message: this.$locale("form.plsSelectPlatform"), trigger: "blur" } ],
      },
      cinemaList: []
    };
  },
  methods: {
    regenClose_fn() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          regenCloseService({ ...this.formData,
            date: this.$moment(this.formData.date).format("YYYY-MM-DD") }).then(res => {
            if(res.success) {
              this.$refs.ruleForm.resetFields();
              countDownAlert({ content: this.$locale("global.updateSuccessfully") });
            }
          });
        } else {
          setTimeout(() => {
            const isError = document.getElementsByClassName("is-error");
            isError[0].querySelector("input").focus();
          }, 100);
        }
      });
    }
  },
  components: {
    CommDatePicker
  }
};
</script>
<style lang="less" scoped>
  .confirm {
    margin-top: 40px;
  }
</style>